/** Uno - Planner browser cache async storage prefix */ export const PlannerAsyncStoragePrefix = "Planner";
/** Evo - Planner browser cache async storage prefix */ export const PlannerV2AsyncStoragePrefix = "PlannerV2";
/** Key for storing ViewStore ViewConfig data in localStorage (array order = LRU order, index 0 = most recent) */ export const ViewStoreViewConfigKey = "vstore-vconfig";
/**
 * localStorage keys for each globally-scoped (non per-view) view setting row.
 * Each property name corresponds to a GlobalViewSettings table row; the value is both the row key and the localStorage persistence key
 */ export const GlobalViewSettingKeys = {
    /** Global task editor render mode preference (dialog vs panel). */ TaskEditorRenderMode: "vstore-task-editor-render-mode"
};
/** Key for storing the global task editor active side panel preference in localStorage */ export const ViewStoreTaskEditorActiveSidePanelKey = "vstore-task-editor-active-side-panel";
/** Key for storing the global task editor side panel width preference in localStorage */ export const ViewStoreTaskEditorSidePanelWidthKey = "vstore-task-editor-side-panel-width";
/**
 * Legacy key for the global task editor chat pane open preference (boolean).
 * Superseded by {@link ViewStoreTaskEditorActiveSidePanelKey}; retained only so we can migrate a
 * previously-persisted `true` value into the new side panel enum on read.
 */ export const LegacyViewStoreTaskChatPaneOpenKey = "vstore-task-chat-pane-open";
/**
 * Evo - Planner browser cache async storage schema version
 * upgraded from version 1 to 2 for view config settings
 * upgraded from version 2 to 3 for custom field definitions
 * upgraded from version 3 to 4 for pinned tasks table
 * upgraded from version 4 to 5 for my tasks order table
 * upgraded from version 5 to 6 for dynamic filters table
 * upgraded from version 6 to 7 for task chats table
 * upgraded from version 7 to 8 for the Planner Default Plan ID
 * upgraded from version 8 to 9 for photo tables (user and modern group photo data + status tables)
 * upgraded from version 9 to 10 for dependencies
 */ export const PlannerV2AsyncStorageSchemaVersionV1 = 10;
/** Uno - Planner browser cache async storage schema version V1
 * This version is used for shipping Mru store persistence - mru items and collection status
 */ export const PlannerAsyncStorageSchemaVersionV1 = 1;
/** Uno - Planner browser cache async storage schema version V2
 * This is the latest supported schema version.
 */ export const PlannerAsyncStorageSchemaVersionV2 = 3;
/** Evo - key paths for the respective object stores defined in the schema */ export var PlannerPersistedObjectStoreKeys = /*#__PURE__*/ function(PlannerPersistedObjectStoreKeys) {
    PlannerPersistedObjectStoreKeys["Mru"] = "server_doc_id";
    PlannerPersistedObjectStoreKeys["Plans"] = "id";
    PlannerPersistedObjectStoreKeys["Buckets"] = "id";
    PlannerPersistedObjectStoreKeys["Tasks"] = "id";
    PlannerPersistedObjectStoreKeys["Status"] = "key";
    PlannerPersistedObjectStoreKeys["Goals"] = "id";
    PlannerPersistedObjectStoreKeys["ViewConfig"] = "viewId";
    PlannerPersistedObjectStoreKeys["Cfd"] = "id";
    PlannerPersistedObjectStoreKeys["PinnedTasks"] = "taskId";
    PlannerPersistedObjectStoreKeys["TaskOrder"] = "id";
    PlannerPersistedObjectStoreKeys["ChatMessages"] = "id";
    PlannerPersistedObjectStoreKeys["DynamicFilter"] = "id";
    PlannerPersistedObjectStoreKeys["PlannerDefaultPlanId"] = "key";
    PlannerPersistedObjectStoreKeys["Dependencies"] = "id";
    /** Shared key path for photo object stores (user and modern group photos) */ PlannerPersistedObjectStoreKeys["Photos"] = "id";
    return PlannerPersistedObjectStoreKeys;
}({});
/** Evo - Index names for the respective object stores defined in the schema */ export var PlannerPersistedObjectStoreIndexNames = /*#__PURE__*/ function(PlannerPersistedObjectStoreIndexNames) {
    PlannerPersistedObjectStoreIndexNames["MruPinnedIndex"] = "isPinnedString";
    PlannerPersistedObjectStoreIndexNames["BucketsPlanIndex"] = "planId";
    PlannerPersistedObjectStoreIndexNames["TasksPlanIndex"] = "planId";
    PlannerPersistedObjectStoreIndexNames["TasksMyDayDateIndex"] = "myDayDate";
    PlannerPersistedObjectStoreIndexNames["TasksAssigneeIdentityIdIndex"] = "assigneeIdentityIds";
    PlannerPersistedObjectStoreIndexNames["GoalsPlanIndex"] = "planId";
    PlannerPersistedObjectStoreIndexNames["CfdPlanIndex"] = "planId";
    PlannerPersistedObjectStoreIndexNames["ChatMessagesParentEntityIndex"] = "parentEntityId";
    PlannerPersistedObjectStoreIndexNames["DependencyPlanIndex"] = "planId";
    return PlannerPersistedObjectStoreIndexNames;
}({});
/** Evo - Shape of a single hydration request when rehydrating stores from the browser cache */ export var CacheHydrationRequestType = /*#__PURE__*/ function(CacheHydrationRequestType) {
    /** A single root entity, such as a plan or a task */ CacheHydrationRequestType["Single"] = "single";
    /** A collection of entities related to a parent entity, such as the tasks in a plan */ CacheHydrationRequestType["Collection"] = "collection";
    return CacheHydrationRequestType;
}({});
/** Evo - Checkpoints reported through the StoreHydration performance marker for cache hydration */ export var CacheHydrationState = /*#__PURE__*/ function(CacheHydrationState) {
    /** Hydration of the store from cache has started */ CacheHydrationState["Start"] = "Start";
    /** Cached data was successfully hydrated into the store */ CacheHydrationState["End"] = "End";
    return CacheHydrationState;
}({});
/** Uno - key paths for the respective object stores defined in the schema */ export var PersistedObjectStoreKeys = /*#__PURE__*/ function(PersistedObjectStoreKeys) {
    PersistedObjectStoreKeys["Mru"] = "server_doc_id";
    PersistedObjectStoreKeys["Plans"] = "id";
    PersistedObjectStoreKeys["Buckets"] = "id";
    PersistedObjectStoreKeys["Tasks"] = "id";
    PersistedObjectStoreKeys["Status"] = "key";
    return PersistedObjectStoreKeys;
}({});
/** Uno - Index names for the respective object stores defined in the schema */ export var PersistedObjectStoreIndexNames = /*#__PURE__*/ function(PersistedObjectStoreIndexNames) {
    PersistedObjectStoreIndexNames["MruPinnedIndex"] = "isPinnedString";
    PersistedObjectStoreIndexNames["BucketsPlanIndex"] = "planId";
    PersistedObjectStoreIndexNames["TasksPlanIndex"] = "planId";
    PersistedObjectStoreIndexNames["TasksMyDayDateIndex"] = "myDayDate";
    PersistedObjectStoreIndexNames["TasksAssignmentsIndex"] = "assigneeIds";
    return PersistedObjectStoreIndexNames;
}({});
/**
 * localStorage key used by the old MyTasks new-experience toggle.
 * Read once during bootstrap to migrate the user's preference into the URL, then removed.
 */ export const NewMyTasksExperienceLocalStorageKey = "planner_useNewMyTasksExperience";
